<template>
  <div class="auth-login-wrapper d-flex flex-column">
    <!-- LOGIN HEADER -->
    <div class="d-flex flex-column align-center">
      <img :src="logo" alt="Anty Logo" />
      <p class="auth-login-form-title text-primary--text d-flex align-center mt-8 mb-0">
        {{ $t('auth.login.welcomeBack') }}
        <img :src="cool" alt="cool" class="auth-form-cool-icon ml-2" />
      </p>
      <p class="auth-login-form-text ma-0 mt-2 text-caption--text">
        {{ $t('auth.login.timeToCatchUp') }}
      </p>
    </div>
    <form
      @keydown.enter.prevent="login"
      @submit.prevent="login"
      class="auth-login-input-button-container d-flex flex-column align-center"
    >
      <!-- EMAIL INPUT -->
      <auth-input
        :value="loginForm.username"
        :placeholder-and-label="{
          label: 'auth.login.emailLabel',
          placeholder: 'auth.login.enterYourEmail',
          name: 'username'
        }"
        :error-state="{
          errorMessage: loginErrorMessage,
          errorStatus: Boolean(loginErrorMessage),
          fromWhere: 'login'
        }"
        :handle-change-value="changeInputValue"
      />
      <div class="d-flex flex-column auth-password-input-container">
        <!-- PASSWORD INPUT -->
        <auth-input
          :value="loginForm.password"
          :placeholder-and-label="{
            label: 'auth.login.passwordLabel',
            placeholder: 'auth.login.enterYourPassword',
            name: 'password'
          }"
          :error-state="{
            errorMessage: passwordErrorMessage,
            errorStatus: Boolean(passwordErrorMessage),
          }"
          type="password"
          :handle-change-value="changeInputValue"
        />
        <div
          v-if="showCaptcha"
          class="captcha"
        >
          <captcha-wrapper
            captcha-id="login-captcha"
            :captcha-type="captchaType"
            @handle-captcha-response="handleCaptchaResponse"
          />
        </div>
        <!-- FORGOT PASSWORD BUTTON -->
        <p class="mb-0 auth-forgot-password-text" @click="goToForgotPassword">
          {{ $t('auth.login.forgotPassword') }}
        </p>
      </div>
      <!-- EMAIL CONFIRMATION -->
      <div :class="{'shake' : animated}">
        <auth-login-account-activation v-if="emailConfirmActivation" />
      </div>
      <!-- LOGIN BUTTON -->
      <auth-button size="md" :loading="loading" type="submit">
        {{ $t('auth.login.login') }}
      </auth-button>
      <!-- GO TO REGISTER BUTTON -->
      <p class="mb-0 auth-dont-have-account-text" @click="goToRegister">
        {{ $t('auth.login.dontHaveAccount') }}
      </p>
    </form>
    <div v-if="attemptAccessAccount">
      <dialogs-attempt-access-account
        @closeDialog="closeAttemptAccessAccountDialog"
        @toggleTwoFactor="toggleTwoFactorAuth"
      />
    </div>
  </div>
</template>
<script>
import DialogsAttemptAccessAccount from '@/components/dialogs/DialogsAttemptAccessAccount.vue'
import AuthLoginAccountActivation from '@/components/auth/components/AuthLoginAccountActivation.vue'
import PasswordValidation from '@/components/auth/components/PasswordValidation.vue'
import AuthButton from '@/components/auth/components/AuthButton.vue'
import AuthInput from '@/components/auth/components/AuthInput.vue'
import AuthAlert from '@/components/auth/components/AuthAlert.vue'
import captcha from '@/mixins/captcha'
import CaptchaWrapper from '@/components/CaptchaWrapper.vue'
import Icon from '@/assets/icons/Icon.vue'
import cool from '@/assets/auth/cool.png'
import logo from '@/assets/antyLogo.svg'
import { mapGetters } from 'vuex'
import { MT_CAPTCHA_NAME } from '@/constants/auth/captcha'
import { validateEmail } from '@/helpers/auth'
import { deleteCookieWithDote, getMathHeaders } from '@/utils/helpers'

export default {
  name: 'AuthLogin',

  comments: {
    CaptchaWrapper,
  },

  mixins: [ captcha ],

  computed: {
    ...mapGetters({
      isEmailConfirmed: 'auth/isEmailConfirmed',
      loading: 'auth/loading'
    }),

    emailConfirmActivation () {
      if(!this.isEmailConfirmed && this.loginForm.username && this.loginForm.password) return true

      return false
    }
  },

  components: {
    DialogsAttemptAccessAccount,
    CaptchaWrapper,
    Icon,
    AuthAlert,
    PasswordValidation,
    AuthLoginAccountActivation,
    AuthButton,
    AuthInput
  },

  data() {
    return {
      loginForm: {
        username: '',
        password: '',
        captcha: null
      },
      loginErrorMessage: '',
      passwordErrorMessage: '',
      cool,
      logo,
      showCaptcha: false,
      captchaType: MT_CAPTCHA_NAME,
      animated: false,
      attemptAccessAccount: false,
      twoFactorAuth: false,
    }
  },

  created() {
    this.$store.dispatch('auth/setIsEmailConfirmed', true)
  },

  methods: {
    closeAttemptAccessAccountDialog () {
      this.attemptAccessAccount = false
    },

    toggleTwoFactorAuth () {
      this.twoFactorAuth = true
    },


    handleCaptchaResponse(response) {
      this.loginForm.captcha = response
    },

    changeInputValue(value, type) {
      this.loginForm[type] = value

      this.$store.dispatch('auth/setIsEmailConfirmed', true)
    },

    clearErrorMessages() {
      this.loginErrorMessage = ''
      this.passwordErrorMessage = ''
    },

    async login() {
      try {
        console.log(('deleteCookieWithDote login'))

        deleteCookieWithDote('dolphinAntyAccessToken')
        deleteCookieWithDote('dolphinAntyRefreshToken')
      } catch (e) {
        console.error(e)
      }

      if (event?.target?.classList[0] === 'auth-login-account-activation-send-button') return
      if (event?.submitter?.className.includes('show-button')) return

      const { username, password } = this.loginForm

      if (username.trim() === '' || password.trim() === '') {
        this.clearErrorMessages()

        if (username.trim() === '' && password.trim() === '') {
          this.loginErrorMessage = 'auth.login.requiredField'
          this.passwordErrorMessage = 'auth.login.requiredField'
        }

        if (username.trim() === '') {
          this.loginErrorMessage = 'auth.login.requiredField'
        }
        if (password.trim() === '') {
          this.passwordErrorMessage = 'auth.login.requiredField'
        }

        return
      }

      this.clearErrorMessages()

      if (!validateEmail(username)) {
        this.loginErrorMessage = 'auth.registration.emailError'
        return
      }

      this.clearErrorMessages()
      this.$store.dispatch('auth/setLoading', true)

      try {
        if (this.emailConfirmActivation){
          this.startShake()
        }
        const mathHeaders = await getMathHeaders();
        const response = await this.api.post(
          '/auth/login',
          this.loginForm,
          {
            headers: {
              ...this.api.headers,
              ...mathHeaders,
              'X-Content-Pragma': 'soft'
            }
          }
        )

        if (response.status === 200) {
          if (response?.data?.twoFactoryByEmail) {
            this.$route.params.userInfo = {
              password: this.loginForm.password,
              userId: response.data.userId,
              username: this.loginForm.username,
              time: response.data.time,
              location: response.data.location,
            }
            this.attemptAccessAccount = true
          } else if (response?.data?.twoFactory) {
            await this.$router.push({
              name: 'TwoFa',
              params: {
                username: this.loginForm.username,
                password: this.loginForm.password
              }
            })
          } else {
            const { token: accessToken, refresh_token: refreshToken }  = response.data

            localStorage.setItem('confirmToken', accessToken)
            localStorage.setItem('confirmRefreshToken', refreshToken)

            await this.$store.dispatch('main/loadProfileForVerification', {
              accessToken,
              refreshToken,
            })
          }
        }
      } catch (err) {
        if (this.showCaptcha) {
          this.resetCaptcha(this.captchaType, 'forgot-password-captcha', this.handleResetHcaptcha)
        }

        if (err.response && err.response.status === 400) {
          this.showCaptcha = true
          this.captchaType = err.response.data
        }

        if (err.response && err.response.status === 401) {
          this.loginErrorMessage = 'auth.login.incorrectEmailOrPassword'
          this.passwordErrorMessage = 'auth.login.incorrectEmailOrPassword'
        }
      } finally {
        this.$store.dispatch('auth/setLoading', false)
      }
    },

    handleResetHcaptcha() {
      this.$refs?.captchaWrapper.$refs.captcha?.reset()
    },

    goToRegister() {
      this.$router.push({ name: 'Registration' })
    },

    goToForgotPassword() {
      this.$router.push({ name: 'ForgotPassword' })
    },

    startShake() {
      this.animated = true
      setTimeout(() => {
        this.animated = false
      }, 1000)
    }
  }
}
</script>
<style lang='scss'>
.auth-login-wrapper {
  gap: 32px;
  width: 400px;
  flex-shrink: 0;
}

.auth-login-form-title {
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
}

.auth-login-form-text {
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}

.auth-form-cool-icon {
  width: 20px;
  height: 20px;
}

.auth-login-input-button-container {
  gap: 24px;
}

.auth-password-input-container {
  gap: 16px;
  width: 100%;
}

.auth-forgot-password-text {
  width: fit-content;
  color: var(--v-link-primary-text-default-base, #b645ee);
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  border-bottom: 1px solid var(--v-link-primary-border-default-base, #f4e3fd);
  cursor: pointer;
}

.auth-dont-have-account-text {
  color: var(--v-link-primary-text-default-base, #b645ee);
  font-family: Roboto, sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  border-bottom: 1px solid var(--v-link-primary-border-default-base, #f4e3fd);
  text-align: center;
  width: fit-content;
  cursor: pointer;
}

.shake {
  animation: shake 1s ease-in both;
  transform: translate3d(0, 0, 0);
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(6px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(-6px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(6px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(-6px, 0, 0);
  }
}
</style>
